import { useState, useEffect, useCallback } from 'react';
import API from '../common/api.js';

const useDynamicContentTopics = () => {
    const [dynamicContentTopics, setDynamicContentTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [initialized, setInitialized] = useState(false);

    const loadData = useCallback(async () => {
        setLoading(true);
        setErrorMessage(null);

        let dynamicContentTopicsIfSuccess = await API.getDynamicContentTopics();

        if (dynamicContentTopicsIfSuccess) {
            setDynamicContentTopics(dynamicContentTopicsIfSuccess);
            setInitialized(true);
        } else {
            setErrorMessage('Failed to load dynamic content topics from server. Please retry.');
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return {
        dynamicContentTopics,
        loading,
        errorMessage,
        initialized,
        reload: loadData,
    };
};

export default useDynamicContentTopics;
